export default "__VITE_ASSET__BSIfo$6k__"